<template>
    <div class="cbs-breadcrumb">
        <span v-for="(item, index) in items" :key="index">
            <a
                class="link"
                target="_blank"
                :href="item.link"
            >{{ item.text }}</a>
            <span class="text separator">></span>
        </span>
        <span class="text">{{ currentLabel }}</span>
    </div>
</template>

<script>
import {isOnline} from '../util/helper';
export default {
    props: {
        currentLabel: {
            type: String,
            default: '本地工商注册'
        }
    },
    data() {
        return {
            onlineLink: {
                cloud: 'https://cloud.baidu.com',
                cbs: '/product/cbs',
            },
            sandboxLink: {
                cloud: 'https://cloudtest.baidu.com',
                cbs: '/product/cbs',
            },
            items: []
        };
    },
    mounted() {
        this.initItems();
    },
    methods: {
        initItems() {
            const link = isOnline ? this.onlineLink : this.sandboxLink;
            this.items = [
                {
                    text: '云官网首页',
                    link: this.addTraceToUrl(link.cloud, 'cbs'),
                },
                {
                    text: '工商财税',
                    link: this.addTraceToUrl(link.cbs, 'cbsnav'),
                },
            ];
        },
        addTraceToUrl(url = '', traceValue = 'cbs') {
            const trace = ['trace', 'pageResource'].map(item => `${item}=${traceValue}`).join('&');
            return `${url}${url.includes('?') ? '&' : '?'}${trace}`;
        }
    }
};
</script>

<style lang="less" scoped>
.cbs-breadcrumb {
    padding: 16px 0;
    font-size: 14px;
    .link {
        color: #222;
        text-decoration: none;
    }
    .link:hover {
        color: #2468f2;
    }
    .text {
        color: #222;
        opacity: 0.7;
    }
    .separator {
        margin:  0 8px;
    }
}
</style>
